import { Includes } from './PolyFillFunctions';

/**
 * Remove the thousands seperator from a string and return the modified string
 * @param value the value with a thousands separator
 * @param thousands the thousands separator
 */
export const removeThousands = (value, thousands) => {
	return value.split(thousands).join("");
};

export const convertDecimalToPeriod = (value, decimal) => {
	return value.replace(decimal, '.');
};

export const convertNegativeToProperDash = (value, negative) => {
	return value.replace(negative, "-");
};

export const formatToAFloat = (value, thousands, decimal, negative) => {
	let temp;

	temp = removeThousands(value, thousands);

	temp = convertDecimalToPeriod(temp, decimal);
	temp = convertNegativeToProperDash(temp, negative);

	return parseFloat(temp);
};

export const checkNextPropsWhileNotTyping = (value, hasFocusOrIsTyping) => {
	if ((value || value === '' || value === 0) && !hasFocusOrIsTyping) {
		return true;
	} else {
		return false;
	}
};

export const checkAcceptableChangeState = (value, negative, decimal) => {
	if (value === '' || value === negative || value === negative + decimal
		|| value === decimal) {
		return true;
	} else {
		return false;
	}
};

export const undesirableCurrencyFieldStates = (value, negative, decimal) => {
	if (value === negative + negative
		|| value === negative + decimal + decimal ||
		value === decimal + negative || value === decimal + decimal
		|| value === negative + decimal + negative) {
		return true;
	} else {
		return false;
	}
};

export const checkForOneDecimal = (value, decimal) => {
	if (Includes(value, decimal)) {
		if (value.match(new RegExp("[" + decimal + "]", "g")).length !== 1) {
			return true;
		}
	}
	return false;
};

export const checkforOneDecimalAndMaxDecimalUnits = (value, decimal, maxUnits) => {
	if (Includes(value, decimal)) {
		if (value.substring(value.indexOf(decimal)).length > maxUnits + 1 ||
			value.match(new RegExp("[" + decimal + "]", "g")).length !== 1) {
			return true;
		}
	}
	return false;
};

export const checkForOneNegativeAtProperLocation = (value, negative, negativeAtStart) => {
	if (Includes(value, negative)) {
		if (value.match(new RegExp("[-" + negative + "]", "g")).length !== 1
			|| (value.substring(0, 1) !== negative && negativeAtStart)
			|| (value.substring(value.length - 1) !== negative && !negativeAtStart)) {
			return true;
		}
	}
	return false;
};

/**
  * Get the max characters allowed.
  */
export const generateMaxLength = (value, maxLength, decimal, maxDecimalUnits) => {
	if (maxLength > 16) {
		maxLength = 16;
	}
	const standardLength = 13;
	const decimalUnits = maxDecimalUnits ? maxDecimalUnits + 1 : 0;
	const includesDecimal = decimal && value ? Includes(value, decimal) : false;
	const length = maxLength ? maxLength : standardLength;

	if (includesDecimal) {
		return length + decimalUnits;
	} else {
		return length + 1;
	}
};

export const checkDecimalAgainstMaxLength = (value, decimal, maxLength) => {
	if (value && decimal) {
		if (value.length >= maxLength) {
			return Includes(value, decimal);
		}
	}
	return true;

};

export const checkForLeftSideLength = (value, maxLength, decimal) => {
	let temp = value;
	if (Includes(value, decimal)) {
		temp = value.substring(0, value.indexOf(decimal));
	}
	if (temp.length > maxLength) {
		return false;
	}
	return true;
};

export const regexCreator = (negative, decimal, thousands) => {
	let baseRegex = '^([\b^0-9' + thousands + '.' + negative + '])*$';
	return baseRegex.replace(".", decimal);
};

/**
* Generate a regex that will only allow numbers, backspace, and the decimal separator
* This will be used to exclude any keystrokes outside of this scope.
*/
export const generateCurrencyRegex = (negative, decimal) => {
	const baseRegex = '^([\b0-9.' + negative + '])*$';
	return baseRegex.split(".").join(decimal);
};

//can return Object, String, Number, Boolean, Null and Undefined
export const typeOf = (value) => {
	return Object.prototype.toString.call(value).slice(8, -1);
};



// WEBPACK FOOTER //
// ./src/utils/NumberUtils.js